<template>
  <b-modal id="profile-pic" title="Profile Picture" hide-footer>
    <h4>Upload New Profile Picture</h4>
    <b-form @submit.prevent="upload">
      <b-form-file
        v-model="file"
        placeholder="Choose a file or drop it here..."
        drop-placeholder="Drop file here..."
        accept="image/*"
        required
      ></b-form-file>
      <div class="mt-3 text-right">
        <b-button @click="cancel">Cancel</b-button>
        <b-button type="submit" variant="danger">Upload</b-button>
      </div>
    </b-form>
  </b-modal>
</template>

<script>
import axios from 'axios';
import errorsMixin from '@/mixins/errors-mixin';
import { mapGetters } from 'vuex';

export default {
  mixins: [errorsMixin],
  data() {
    return {
      file: [],
      formData: {}
    }
  },
  computed: {
    ...mapGetters({
      userRoute: 'profile/userRoute'
    }),
  },
  methods: {
    async upload() {
      let formData = new FormData();
      formData.append('file', this.file);

      await axios.post(this.userRoute + "/profile/upload", formData, {
        headers: {
          'Content-Type': "multipart/form-data; charset=utf-8; boundary=" + Math.random().toString().substr(2)
        }
      })
      .then(response => {
        this.file = [];
        this.$store.dispatch('profile/user');
        this.$bvModal.hide('profile-pic');
      })
      .catch(error => {
        this.error(error);
      });
    },
    fileUploaded(file) {
      this.file = file;
    },
    cancel() {
      this.$bvModal.hide('profile-pic');
    }
  }
};
</script>